import { render, staticRenderFns } from "./post_tags.vue?vue&type=template&id=0fa83af5&scoped=true&"
import script from "./post_tags.vue?vue&type=script&lang=js&"
export * from "./post_tags.vue?vue&type=script&lang=js&"
import style0 from "./post_tags.vue?vue&type=style&index=0&id=0fa83af5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa83af5",
  null
  
)

export default component.exports